import React from 'react';

import { useAccount } from '@/hooks/useAccount';

import { useGirlBackgroundImage } from '../../hooks/useGirlBackgroundImage';
import { useManBackgroundImage } from '../../hooks/useManBackgroundImage';

import MultigenderAioBase from './MultigenderAioBase';

const MultigenderAioVariant: React.FC = () => {
  const { user } = useAccount();
  const girlBackgroundImage = useGirlBackgroundImage();
  const manBackgroundImage = useManBackgroundImage();

  const backgroundImage =
    user?.onboarding_data.gender === 'male'
      ? manBackgroundImage
      : girlBackgroundImage;

  return <MultigenderAioBase backgroundImage={backgroundImage} />;
};

export default MultigenderAioVariant;
